import { useState } from 'react';
import { Alert, Box, Tab, Tabs } from '@mui/material';

import { MaterialReportTable } from '../../../common/components';
import { REPORT_COLUMNS } from '../../../common/components/materials/materialPresentationConstants';
import { MATERIAL_HISTORY_TEXTS } from '../constants/inventoryArticlesConstants';

const SECTIONS = [
  { key: 'layers', title: MATERIAL_HISTORY_TEXTS.fifoSources, columns: REPORT_COLUMNS.layers },
  {
    key: 'purchases',
    title: MATERIAL_HISTORY_TEXTS.purchaseHistory,
    columns: REPORT_COLUMNS.purchases,
  },
];

const tabsSx = {
  minHeight: 40,
  '& .MuiTab-root': {
    minHeight: 40,
    fontSize: 13,
    fontWeight: 700,
  },
};

/**
 * Costos del artículo por documento, en pestañas: capas FIFO y compras, ordenables por columna.
 * @param {Object} props
 * @param {Object} props.layers Capas FIFO: filas, total, página y estado.
 * @param {Object} props.purchases Compras: filas, total, página y estado.
 * @returns {JSX.Element}
 */
const MaterialArticleHistory = ({ layers, purchases }) => {
  const [activeKey, setActiveKey] = useState(SECTIONS[0].key);
  const sectionData = { layers, purchases };
  const activeSection = SECTIONS.find((section) => section.key === activeKey);
  const data = sectionData[activeKey];

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={activeKey}
          onChange={(_, value) => setActiveKey(value)}
          variant="scrollable"
          scrollButtons="auto"
          sx={tabsSx}
        >
          {SECTIONS.map((section) => (
            <Tab key={section.key} value={section.key} label={section.title} />
          ))}
        </Tabs>
      </Box>
      {data.errorMessage !== null && (
        <Alert severity="error">{data.errorMessage || MATERIAL_HISTORY_TEXTS.loadError}</Alert>
      )}
      <MaterialReportTable
        rows={data.rows}
        columns={activeSection.columns}
        total={data.total}
        page={data.page}
        onPage={data.setPage}
        rowsPerPage={data.rowsPerPage}
        onRowsPerPageChange={data.handleRowsPerPageChange}
        isLoading={data.isLoading}
        hasMaxHeight={false}
        sort={data.sort}
        onSort={data.onSort}
      />
    </Box>
  );
};

export default MaterialArticleHistory;
